import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaInstagram, FaEnvelope } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { colors, fonts } from "../styles/colors";
import { useExternalLink } from "../hooks/useExternalLink";

const FooterContainer = styled.footer`
  background: ${colors.inkBlack};
  color: white;
  padding: 3rem 0 1rem;
  margin-top: 4rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    margin-bottom: 1rem;
    font-size: 1.2rem;
    font-family: ${fonts.heading};
    font-weight: 600;
  }

  p {
    margin-bottom: 0.5rem;
    line-height: 1.6;
    font-family: ${fonts.body};
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  color: white;
  font-size: 1.5rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.dustyRose};
  }
`;

const FooterLink = styled(Link)`
  color: white;
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
  margin-bottom: 0.5rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  text-align: left;

  &:hover {
    color: ${colors.dustyRose};
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${colors.coolTaupe};
  color: #ccc;
  font-family: ${fonts.body};
`;

const Footer = () => {
  const handleExternalLink = useExternalLink();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>Shana Marie Roark</h3>
          <p>Poet, entrepreneur, and founder</p>
          <p>Exploring love, life, and the human experience through poetry.</p>
        </FooterSection>

        <FooterSection>
          <h3>Services</h3>
          <FooterLink to="/events">Live Poetry Events</FooterLink>
          <FooterLink to="/product/custom-speeches">Custom Speeches</FooterLink>
          <FooterLink
            as="button"
            onClick={() =>
              handleExternalLink(
                "https://0c1c94-91.myshopify.com/products/custom-poems",
                "Custom Poems",
                "footer_services"
              )
            }
          >
            Custom Poems
          </FooterLink>
          <FooterLink
            as="button"
            onClick={() =>
              handleExternalLink(
                "https://0c1c94-91.myshopify.com/products/poem-club",
                "Poem Club",
                "footer_services"
              )
            }
          >
            Poem Club
          </FooterLink>
        </FooterSection>

        <FooterSection>
          <h3>Contact</h3>
          <p>Email: shana@shanaroark.com</p>
          <p>Based in New York City</p>
          <SocialLinks>
            <SocialLink
              href="https://www.instagram.com/supergirlreject"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </SocialLink>
            <SocialLink
              href="https://www.tiktok.com/@supergirlreject"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <FaTiktok />
            </SocialLink>
            <SocialLink
              href="https://www.youtube.com/@supergirlreject"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </SocialLink>
            <SocialLink href="mailto:shana@shanaroark.com" aria-label="Email">
              <FaEnvelope />
            </SocialLink>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <h3>Quick Links</h3>
          <FooterLink to="/about">About Shana</FooterLink>
          <FooterLink to="/books">Published Books</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterSection>
      </FooterContent>

      <Copyright>
        <p>
          &copy; {new Date().getFullYear()} Shana Marie Roark. All rights
          reserved.
        </p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
